import { defineStore } from 'pinia'
import { ref } from 'vue'
import api from '../api'
import { useUserStore } from './userStore'
import type { RecentItemDto } from '../dtos'

// "Recent items" — the user's recently-touched songs and mixes. Server-side
// list is driven by an upsert in UserActivityService whenever the user mutates
// a song or a mix (or any of their children).
export const useRecentStore = defineStore('recent', () => {
    const userStore = useUserStore()
    const items = ref<RecentItemDto[]>([])
    const loading = ref(false)

    async function fetchRecent(limit = 20) {
        if (!userStore.user) return
        loading.value = true
        try {
            const token = await userStore.user.getIdToken()
            const response = await api.get(`/users/me/recent?limit=${limit}`, {
                headers: { Authorization: `Bearer ${token}` }
            })
            items.value = response.data
        } catch (error) {
            console.error('Failed to fetch recent items:', error)
        } finally {
            loading.value = false
        }
    }

    function clear() {
        items.value = []
    }

    return { items, loading, fetchRecent, clear }
})
